import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpErrorResponse } from '@angular/common/http';
import { catchError, Observable, throwError } from 'rxjs';
import errorMessages from '../../../common/constants/errorMessages';
import { AuthService } from '../../../features/auth/services/auth.service';
import ResponseCode from '../../../common/constants/responseCodes';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor(private authService: AuthService) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === ResponseCode.UNAUTHORIZED.code) {
          // Token expirado. Intentar refresh y reintentar la solicitud original.
          return this.handle401Error(request, next);
        }

        const errorMessage = this.getErrorMessage(error);
        return throwError(() => errorMessage);
      }),
    );
  }

  private handle401Error(
    request: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    return new Observable((observer) => {
      this.authService.refreshToken().then((newToken) => {
        if (newToken) {
          // Clonar request con el nuevo token
          const clonedRequest = request.clone({
            setHeaders: {
              Authorization: `Bearer ${newToken}`,
            },
          });

          // Reintentar la solicitud
          next.handle(clonedRequest).subscribe({
            next: (event) => observer.next(event),
            error: (err) => observer.error(err),
            complete: () => observer.complete(),
          });
        } else {
          // No se pudo renovar token, cerrar sesión
          this.authService.logOut();
          observer.error('Sesión expirada. Por favor, inicie sesión nuevamente.');
        }
      });
    });
  }

  private getErrorMessage(error: HttpErrorResponse): string {
    if (error.status === ResponseCode.CONTENT_TOO_LARGE.code) {
      return errorMessages[`${ResponseCode.CONTENT_TOO_LARGE.code}`];
    }

    if (error.error?.error?.message) {
      return errorMessages[error.error.error.message] || ResponseCode.SERVER_ERROR.message;
    }

    if (typeof error.error?.message === 'string' && error.error.message) {
      return errorMessages[error.error.message] || error.error.message;
    }

    return errorMessages[error.message] || ResponseCode.SERVER_ERROR.message;
  }
}
